import { CustomTemplate, CustomTemplateField } from "./customTemplateTypes";

export interface CreateCustomTemplateRequest {
  name: string;
  image: File;
  width: number;
  height: number;
  fields: CustomTemplateField[];
}

export interface UpdateCustomTemplateRequest {
  name?: string;
  fields?: CustomTemplateField[];
}

export function createCustomTemplateApi(token: string | null) {
  const authHeaders = (): HeadersInit => ({
    ...(token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {}),
  });

  return {
    async getAll(): Promise<CustomTemplate[]> {
      const response = await fetch("/api/custom-templates", {
        method: "GET",
        headers: authHeaders(),
      });

      if (!response.ok) {
        throw new Error(
          `Templates konnten nicht geladen werden (${response.status}).`
        );
      }

      return await response.json();
    },

    async getById(id: string): Promise<CustomTemplate> {
      const response = await fetch(`/api/custom-templates/${id}`, {
        method: "GET",
        headers: authHeaders(),
      });

      if (!response.ok) {
        throw new Error(
          `Template konnte nicht geladen werden (${response.status}).`
        );
      }

      return await response.json();
    },

    async create(
      data: CreateCustomTemplateRequest
    ): Promise<CustomTemplate> {
      const formData = new FormData();

      formData.append("name", data.name);
      formData.append("image", data.image);
      formData.append("width", String(data.width));
      formData.append("height", String(data.height));

      formData.append(
        "fields",
        JSON.stringify(data.fields)
      );

      const response = await fetch("/api/custom-templates", {
        method: "POST",
        headers: authHeaders(),
        body: formData,
      });

      if (!response.ok) {
        throw new Error(
          `Template konnte nicht gespeichert werden (${response.status}).`
        );
      }

      return await response.json();
    },

    async update(
      id: string,
      data: UpdateCustomTemplateRequest
    ): Promise<CustomTemplate> {
      const response = await fetch(`/api/custom-templates/${id}`, {
        method: "PATCH",
        headers: {
          ...authHeaders(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(
          `Template konnte nicht aktualisiert werden (${response.status}).`
        );
      }

      return await response.json();
    },

    async remove(id: string): Promise<void> {
      const response = await fetch(`/api/custom-templates/${id}`, {
        method: "DELETE",
        headers: authHeaders(),
      });

      if (!response.ok) {
        throw new Error(
          `Template konnte nicht gelöscht werden (${response.status}).`
        );
      }
    },
  };
}